import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

/** Data aceptada: lista de imágenes (abre en la primera) o lista + índice inicial. */
export type ImagesCarouselData = string[] | { images: string[]; startIndex?: number };

@Component({
  selector: 'app-images-carousel',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './images-carousel.component.html',
  styleUrls: ['./images-carousel.component.scss']
})
export class ImagesCarouselComponent {
  images: string[] = [];
  currentIndex = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ImagesCarouselData) {
    if (Array.isArray(data)) {
      this.images = data;
    } else {
      this.images = data?.images ?? [];
      this.select(data?.startIndex ?? 0);
    }
  }

  next() {
    if (this.images.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }
  }

  prev() {
    if (this.images.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    }
  }

  select(index: number) {
    if (index >= 0 && index < this.images.length) {
      this.currentIndex = index;
    }
  }
}
